import React, { Component } from 'react'
import PropTypes from 'prop-types'

import CSSModules from 'react-css-modules'
import { Button } from 'react-toolbox/lib/button'
import Input from 'react-toolbox/lib/input'
import { Flex, Box } from 'reflexbox'

import styles from './styles.scss'

class CommentBox extends Component {
  static propTypes = {
    onSubmit: PropTypes.func.isRequired
  }

  constructor(props){
    super(props)
    this.state = {
      comment: ''
    }
  }

  onCommentChanged(comment){
    this.setState({
      ...this.state,
      comment
    })
  }

  clearComment(){
    this.setState({
      ...this.state,
      comment: ''
    })
  }

  submitComment(){
    this.props.onSubmit(this.state.comment)
    this.clearComment()
  }

  render (){
    return (
      <Box px={1} pb={1}>
        <Input
          theme={styles}
          type='text'
          label='Add Comment'
          multiline
          value={this.state.comment}
          onChange={(comment) => this.onCommentChanged(comment)}
        />
        <Flex justify='flex-end'>
          <Box pr={2}>
            <Button
              primary
              raised
              label='cancel'
              onClick={ () => this.clearComment() }
            />
          </Box>
          <Button
            primary
            raised
            label='submit'
            onClick={ () => this.submitComment() }
          />
        </Flex>
      </Box>
    )
  }
}

export default CSSModules(CommentBox, styles)
